//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dimensions from "./components/Dimensions";
import barcodes from "./components/Barcodes";
import storage from "./components/Storage";
import accountingSettings from "./components/AccountingSettings";
import price from "./components/Price";
import supplier from "./components/Supplier";
import productdetails from "./components/Details";
import { mapActions } from "vuex";
import router from "../../router";
export default {
  data() {
    return {
      internalID: 0,
      productNumber: "",
      article: {},
      supplierProduct: {},
      isDeleted: false,
      deleted: "check_circle",
      textClass: "text-green",
      productInfoIcon: "",
      tab: "price",
      detailsTab: "details",
      storageTab: "storage",
      supplierTab: "supplier",
    };
  },
  components: {
    productdetails,
    dimensions,
    accountingSettings,
    price,
    storage,
    supplier,
    barcodes
  },

  methods: {
    async getProduct(internalId) {
      console.log("getProduct this.internalID:", internalId);
      if (internalId == 0) {
        this.article = {
          id: 0,
          extId: null,
          productNumber: "",
          productName: "",
          productDescription: "",
          created: null,
          createdBy: null,
          updated: null,
          lastUpdatedBy: null,
          type: null,
          status: null,
          vatTypeId: 0,
          vatName: null,
          accountID: null,
          accountName: null,
          unit: null,
          costPrice: null,
          priceIncVat: null,
          weightedAverageCostPrice: null,
          priceExVat: null,
          listPrice: null,
          avarageCost: null,
          calculateGrossPriceBasedOnNetPrise: null,
          dimension1Id: null,
          dimension1Value: null,
          dimension2Id: null,
          dimension2Value: null,
          dimension3Id: null,
          dimension3Value: null,
          dimension4Id: null,
          dimension4Value: null,
          dimension5Id: null,
          dimension5Value: null,
          dimension6Id: null,
          dimension6Value: null,
          dimension7Id: null,
          dimension7Value: null,
          dimension8Id: null,
          dimension8Value: null,
          dimension9Id: null,
          dimension9Value: null,
          maximumPoint: null,
          minimumPoint: null,
          supplierProduct: this.supplierProduct,
          barcodes:[]
        };
      } else {
        this.article = await this.getArticle(internalId);
        if (this.article.status == 0) {
          this.textClass = "text-red";
          this.deleted = "warning";
          this.productInfoIcon = this.$t("products.productInfoIcon");
        }
      }
      if (this.article.vatTypeId == null) this.article.vatTypeId = 0;
      if (this.article.accountID == null) this.article.accountID = 0;
      this.productNumber = this.article.productNumber;
    },

    async saveProduct() {
      try {
        if (this.internalID == 0) {
          var postProd = {};
          postProd.productName = this.article.productName;
          postProd.productNumber = this.article.productNumber;
          postProd.unit = this.article.unit;
          postProd.type = this.article.type;
          postProd.productDescription = this.article.productDescription;
          postProd.status = 0;
          postProd.PriceIncVat = parseFloat(this.article.salesPrice);
          postProd.PriceExVat = parseFloat(this.article.salesPrice);
          postProd.costPrice = parseFloat(this.article.costPrice);
          postProd.weightedAverageCostPrice = parseFloat(
            this.article.weightedAverageCostPrice
          );
          postProd.accountID = this.article.accountID;

          // postProd.accountID = 285;
          // postProd.costPrice = 0;
          // postProd.priceIncVat = 0;
          // postProd.priceExVat = 0;
          // postProd.listPrice = 0;
          // postProd.avarageCost = 0;
          postProd.calculateGrossPriceBasedOnNetPrise = false;
          postProd.vatTypeId = this.article.vatTypeId;

          postProd.dimension1Id = this.article.dimension1Id;
          postProd.dimension2Id = this.article.dimension2Id;
          postProd.dimension3Id = this.article.dimension3Id;
          postProd.dimension4Id = this.article.dimension4Id;
          postProd.dimension5Id = this.article.dimension5Id;
          postProd.dimension6Id = this.article.dimension6Id;
          postProd.dimension7Id = this.article.dimension7Id;
          postProd.dimension8Id = this.article.dimension8Id;
          postProd.dimension9Id = this.article.dimension9Id;
          postProd.maximumPoint = this.article.maximumPoint;
          postProd.minimumPoint = this.article.minimumPoint;
          postProd.purchaseFrequencyDays = this.article.purchaseFrequencyDays;

          postProd.supplierProduct = this.article.supplierProduct;
          postProd.barcodes = this.article.barcodes;


          var createdDto = await this.postArticle(postProd);
          this.internalID = createdDto.id;
          this.article.barcodes = createdDto.barcodes;
          console.log("created " + this.internalID);
          router.push({
            name: "EditProduct",
            params: { id: this.internalID },
          });
        } else {
          var putProd = {};
          putProd.productName = this.article.productName;
          putProd.productNumber = this.article.productNumber;
          putProd.unit = this.article.unit;
          putProd.type = this.article.type;
          putProd.productDescription = this.article.productDescription;
          putProd.status = this.article.status;
          // putProd.salesPrice = this.article.salesPrice;
          putProd.costPrice = parseFloat(this.article.costPrice);
          putProd.PriceIncVat = parseFloat(this.article.salesPrice);
          putProd.PriceExVat = parseFloat(this.article.salesPrice);
          putProd.weightedAverageCostPrice = parseFloat(
            this.article.weightedAverageCostPrice
          );
          putProd.vatTypeId = this.article.vatTypeId;
          putProd.accountID = this.article.accountID;
          putProd.dimension1Id = this.article.dimension1Id;
          putProd.dimension2Id = this.article.dimension2Id;
          putProd.dimension3Id = this.article.dimension3Id;
          putProd.dimension4Id = this.article.dimension4Id;
          putProd.dimension5Id = this.article.dimension5Id;
          putProd.dimension6Id = this.article.dimension6Id;
          putProd.dimension7Id = this.article.dimension7Id;
          putProd.dimension8Id = this.article.dimension8Id;
          putProd.dimension9Id = this.article.dimension9Id;
          putProd.maximumPoint = this.article.maximumPoint;
          putProd.minimumPoint = this.article.minimumPoint;
          putProd.purchaseFrequencyDays = this.article.purchaseFrequencyDays;

          putProd.barcodes = this.article.barcodes;
          putProd.supplierProduct = this.article.supplierProduct;
          var updateddto = await this.putArticle({
            internalID: this.internalID,
            productDto: putProd,
          });

          this.article.barcodes = updateddto.barcodes;

          this.$notify({
            group: "foo",
            title: "",
            text: this.$t("common.saveOk"),
          });
        }
      } catch (error) {
        console.log("error", error);
        this.$notify({
          group: "foo",
          title: this.$t("common.errorSave"),
          text: error,
          type: "error",
        });
      }
    },

    newProduct() {},

    onReset() {},

    prevItem() {
      console.log("prevItem");
      console.log(this.internalID);
      var i = parseFloat(this.internalID);
      router.push({
        name: "EditProduct",
        params: { id: i - 1 },
      });
    },

    nextItem() {
      console.log("nextItem");
      var i = parseFloat(this.internalID);
      router.push({
        name: "EditProduct",
        params: { id: i + 1 },
      });
    },

    ...mapActions("main", ["getArticle", "putArticle", "postArticle"]),
  },

  created() {
    this.internalID = this.$route.params.id;
    console.log("created " + this.internalID);
    this.getProduct(this.internalID);
  },

  beforeRouteUpdate(to, from, next) {
    this.internalID = to.params.id;
    console.log("beforeRouteUpdate " + this.internalID);
    this.getProduct(this.internalID);
    next();
  },
};
